import { ContestType } from '@betterpool/api-types/contests-service';

import type { ContestV2ItemBase } from '~/services/contests/contests-v2.service.api';

type ContestV2 = ContestV2ItemBase['contest'];

const KNOWN_CONTEST_TYPES: ReadonlySet<string> = new Set(Object.values(ContestType));

const unknownContestTypeAltText = (
  contestType: ContestV2['contestType'],
  contestTypeAltText: ContestV2['contestTypeAltText']
): string | undefined =>
  KNOWN_CONTEST_TYPES.has(contestType) ? undefined : (contestTypeAltText ?? undefined);

export default unknownContestTypeAltText;
